/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const KEY_VALUES_SERVICE = {
    getTikTokVideos
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "keyvalues";

/* Services */
function getTikTokVideos(language = null)
{
    // Language detection priority:
    // 1. Explicit language parameter (if provided)
    // 2. Website locale from localStorage
    // 3. Browser language detection
    // 4. Fallback to 'en'
    if (!language) {
        language = localStorage.getItem('locale') || getBrowserLanguage();
    }
    
    // Build API call with query parameters
    // Endpoint: {API_ROOT}/keyvalues?pageSize=10&pageNumber=1&searchText=&sorter=ascending&propertyName=id
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);
    
    // Query parameters for the API (matches the actual API endpoint)
    const queryParams = {
        pageSize: 10,
        pageNumber: 1,
        searchText: '',
        sorter: 'ascending',
        propertyName: 'id'
    };

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    }; 

    // Process API call, validating the token beforehand.
    return API_HELPER.apiCall(url, queryParams, requestOptions)
        .then(response => {
            // Add the language to the response for the store to use
            return {
                ...response,
                language: language
            };
        });
}

// Helper function to detect browser language
function getBrowserLanguage() {
    const availableLanguages = ["en", "pt", "es"];
    const browserLang = navigator.language || navigator.userLanguage;
    const shortLang = browserLang.split('-')[0]; // Get language code without region (e.g., "en-US" → "en")
    return availableLanguages.includes(shortLang) ? shortLang : "en"; // Fallback to "en" if not supported
}
